// Shared task status model (mirrors the server's TASK_ACTIVE/CLOSED sets) so every surface
// classifies open/in_progress/on_hold as "active" and done/skipped as "closed" consistently.

export const ACTIVE_TASK_STATUSES = ['open', 'in_progress', 'on_hold'];

export const isClosedTask = (status) => status === 'done' || status === 'skipped';
// Explicit set (not !closed) so an unknown/future status is neither active nor closed
// rather than silently treated as outstanding.
export const isActiveTask = (status) => ACTIVE_TASK_STATUSES.includes(status);
